/**
 * Active-fleet store. Single source of truth for "which fleet is the
 * dispatcher currently operating on". Persisted to localStorage so the
 * choice survives reloads.
 *
 * Same useSyncExternalStore pattern as token-store — keeps the fleet store
 * framework-agnostic and avoids a context provider.
 */

const ACTIVE_KEY = 'breaker:activeFleetId';

let activeFleetId: string | null = null;
const subscribers = new Set<() => void>();

function notify() {
  for (const cb of subscribers) cb();
}

// Hydrate from localStorage on module load.
try {
  activeFleetId = localStorage.getItem(ACTIVE_KEY);
} catch {
  // localStorage unavailable — that's fine, in-memory only.
}

export const fleetStore = {
  get(): string | null {
    return activeFleetId;
  },

  set(fleetId: string | null): void {
    if (activeFleetId === fleetId) return;
    activeFleetId = fleetId;
    try {
      if (fleetId === null) localStorage.removeItem(ACTIVE_KEY);
      else localStorage.setItem(ACTIVE_KEY, fleetId);
    } catch {
      // silent
    }
    notify();
  },

  clear(): void {
    this.set(null);
  },

  subscribe(cb: () => void): () => void {
    subscribers.add(cb);
    return () => subscribers.delete(cb);
  },
};
